/**
 * This file is generated from scripts/genIconComponents.js. Any
 * changes should be made in that file.
 */
import React, { forwardRef, Ref } from "react";
import { getSvgResourceForSize, getDefaultSize } from "../../utils";
import { Icon, LodestarIconProps } from "../../icon";
import { SvgArrowRight as ArrowRightMedium } from "./medium/ArrowRight";
const sizeMap = {
    medium: ArrowRightMedium,
};
const defaultSize = getDefaultSize(sizeMap);

export const ArrowRightIcon = forwardRef(
    (
        { size = defaultSize, ...rest }: LodestarIconProps,
        ref: Ref<HTMLElement>
    ) => (
        <Icon
            ref={ref}
            svgComponent={getSvgResourceForSize(sizeMap, size)}
            size={size}
            {...rest}
        />
    )
);
ArrowRightIcon.displayName = "ArrowRightIcon";
